import { render, staticRenderFns } from "./ObsequiosModalPerseo.vue?vue&type=template&id=25481665&scoped=true"
import script from "./ObsequiosModalPerseo.vue?vue&type=script&lang=js"
export * from "./ObsequiosModalPerseo.vue?vue&type=script&lang=js"
import style0 from "./ObsequiosModalPerseo.vue?vue&type=style&index=0&id=25481665&prod&scoped=true&lang=css"
import style1 from "./ObsequiosModalPerseo.vue?vue&type=style&index=1&id=25481665&prod&scoped=true&lang=css"
import style2 from "./ObsequiosModalPerseo.vue?vue&type=style&index=2&id=25481665&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25481665",
  null
  
)

export default component.exports